export class Form {
  name: string;
  email: string;
  subject: string;
  comment: string;
  policyAccepted: boolean;
}
